<template>
	<table class="[&_tr+tr>th]:pt-1 [&_tr+tr>td]:pt-1">
		<tbody>
			<tr v-for="item in pricelist?.children" :key="item._uid">
				<th scope="row" class="font-normal text-left" :colspan="item.description ? 1 : 2">
					{{ item.title }}
				</th>
				<td v-if="item.description" class="pl-4">
					{{ item.description }}
				</td>
				<td
					class="pl-4"
					:class="{
						'text-left': alignPrices === Alignments.LEFT,
						'text-right': alignPrices === Alignments.RIGHT,
					}"
				>
					{{ item.value }}
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script setup lang="ts">
	import type {GeneralPricelistItemStoryblok, GeneralPricelistStoryblok} from '~/storyblok/types';

	interface Props {
		pricelist?: Omit<GeneralPricelistStoryblok, 'children'> & {
			children?: readonly GeneralPricelistItemStoryblok[]
		}
		alignPrices?: 'left' | 'right'
	}

	withDefaults(defineProps<Props>(), {alignPrices: 'right'});

	enum Alignments {
		LEFT = 'left',
		RIGHT = 'right',
	}
</script>
